import { render, staticRenderFns } from "./CardsAction.vue?vue&type=template&id=374fd91a"
import script from "./CardsAction.vue?vue&type=script&lang=js"
export * from "./CardsAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardAction: require('/srv/app/components/card/CardAction.vue').default,CardDefaultIcon: require('/srv/app/components/card/CardDefaultIcon.vue').default})
